import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import Summary from 'Components/Summary';
//Actions
import {
    accountsGetDetailsAccountRequest,
    clearRedux
} from 'Redux/actions';

const AccountDetails = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const { account, loading, openModal, result } = useSelector(state => state.accountDetailsRedux)
    const [ data, setData ] = useState(null)

    const closeModal = () => {
        dispatch(clearRedux("ACCOUNTS_DETAILS"));
        setData(null);
    }

    useEffect(() => {
        if (openModal && account) {
            dispatch(accountsGetDetailsAccountRequest(account))
        }
    }, [openModal])

    useEffect(() => {
        if (result) {
            let currentResult = result
            currentResult = {
                ...currentResult,
                dealer: currentResult?.dealer?.name || '',
                brand: currentResult?.dealer?.brand?.title || '',
            }
            delete currentResult["dealer"]
            setData(currentResult)
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            handleClose={() => closeModal()}
            position="right"
            size="small"
            loading={loading}
            title={messages['accounts_main_account_details']}
        >
            <ModalBody>
                <div style={{ padding: '5px 10px', marginTop: 10, marginBottom: 30 }}>
                    {data && <Summary data={data} columns={2} addDash/>}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-dark-blue"
                    onClick={(e) => closeModal()}
                >
                    {messages['common_close']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}
export default AccountDetails